module.exports = __webpack_public_path__ + "img/m_banner3.2a8866ff.png";